import * as React from "react";
import ReactPDF, { View, Text } from "@react-pdf/renderer";
import Report6PDFTemplateRiskCriteriasGrid from "./Report6PDFTemplateRiskCriteriasGrid";
import { TReport6ReportingPeriodPresentationModel } from "../../../presenter/report/model/Report6ReportingPeriodPresentationModel";

const Report6PDFTemplateReportsGrid = ({
  translate,
  reportingPeriod,
  styles
}: {
  translate: any;
  reportingPeriod: TReport6ReportingPeriodPresentationModel;
  styles: ReactPDF.Styles;
}) => {
  const reports = reportingPeriod.reports;
  return (
    <View style={styles.table}>
      <View style={styles.tableRow}>
        <View style={{ ...styles.tableCol, width: "13%" }}>
          <Text style={styles.tableCell}>
            {translate("report6_preview_reports_grid.report_type_name")}
          </Text>
        </View>
        <View style={{ ...styles.tableCol, width: "6%" }}>
          <Text style={{ ...styles.tableCell, textAlign: "right" }}>
            {translate("report6_preview_reports_grid.version")}
          </Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>
            {translate("report6_preview_reports_grid.submit_date")}
          </Text>
        </View>
        <View style={{ ...styles.tableCol, width: "14%" }}>
          <Text style={styles.tableCell}>
            {translate("report6_preview_reports_grid.submit_reason")}
          </Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>
            {translate(
              "report6_preview_reports_grid.regular_evaluation_status"
            )}
          </Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>
            {translate("report6_preview_reports_grid.regular_evaluation_date")}
          </Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>
            {translate("report6_preview_reports_grid.formal_evaluation_status")}
          </Text>
        </View>
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>
            {translate("report6_preview_reports_grid.formal_evaluation_date")}
          </Text>
        </View>
        <View style={{ ...styles.tableCol, width: "12%" }}>
          <Text style={styles.tableCell}>
            {translate("report6_preview_reports_grid.financial_imbalance")}
          </Text>
        </View>
      </View>
      {reports.map((item, index) => (
        <View key={index}>
          <View style={styles.tableRow} key={index}>
            <View style={{ ...styles.tableCol, width: "13%" }}>
              <Text style={styles.tableCell}>{item.reportTypeName}</Text>
            </View>
            <View style={{ ...styles.tableCol, width: "6%" }}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {item.version}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.submitDate}</Text>
            </View>
            <View style={{ ...styles.tableCol, width: "14%" }}>
              <Text style={styles.tableCell}>{item.submitReason} </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {item.regularEvaluationStatus}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.regularEvaluationDate}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {item.formalEvaluationStatus}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{item.formalEvaluationDate}</Text>
            </View>
            <View style={{ ...styles.tableCol, width: "12%" }}>
              <Text style={styles.tableCell}>
                {item.financialImbalance
                  ? translate("basic.yes")
                  : translate("basic.no")}
              </Text>
            </View>
          </View>
          {item.riskCriterias?.length > 0 && (
            <Report6PDFTemplateRiskCriteriasGrid
              report={item}
              styles={styles}
              translate={translate}
            />
          )}
        </View>
      ))}
    </View>
  );
};

export default Report6PDFTemplateReportsGrid;
